import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useRadioInterviews } from '../hooks/useRadioInterviews';
import './RadioInterviewsPage.css';

const RadioInterviewsPage: React.FC = () => {
  const params = useParams();
  const radioId = params.radioId || '';
  const { radio, interviews, loading, error } = useRadioInterviews(radioId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const placeholderThumb = 'https://via.placeholder.com/480x270/FFD700/000?text=Entrevista';

  return (
    <div className="radio-interviews-container">
      <div className="radio-interviews-wrapper">
        <div className="radio-interviews-topbar">
          <Link to="/radios" className="radio-interviews-back">
            Voltar às Rádios
          </Link>
        </div>

        <div className="radio-interviews-header">
          <div className="radio-interviews-title">
            {radio?.logo ? (
              <img
                className="radio-interviews-logo"
                src={radio.logo}
                alt={radio.name || 'Rádio'}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://via.placeholder.com/220x220/FFD700/000?text=Radio';
                }}
              />
            ) : (
              <div className="radio-interviews-logo-placeholder" />
            )}
            <div>
              <h1>{radio?.name ? `${radio.name} - Entrevistas` : 'Entrevistas'}</h1>
              <p>Lista de entrevistas online (metadados via YouTube)</p>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="radio-interviews-loading">
            <div className="spinner" />
            <p>A carregar entrevistas...</p>
          </div>
        ) : error ? (
          <div className="radio-interviews-error">
            <h2>Erro ao carregar entrevistas</h2>
            <p>{error}</p>
          </div>
        ) : interviews.length === 0 ? (
          <div className="radio-interviews-empty">
            <h3>Nenhuma entrevista encontrada</h3>
            <p>Verifica os documentos em <code>parcerias-entrevistas</code> para esta rádio.</p>
          </div>
        ) : (
          <div className="radio-interviews-grid">
            {interviews.map((it) => (
              <div key={it.id} className="radio-interview-card">
                <div className="radio-interview-thumb">
                  <img
                    src={it.thumbnailUrl || placeholderThumb}
                    alt={it.title || 'Entrevista'}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = placeholderThumb;
                    }}
                  />
                </div>

                <div className="radio-interview-content">
             

                  <h3 className="radio-interview-title">
                    <a
                      href={it.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="radio-interview-title-link"
                    >
                      {it.title || 'Entrevista'}
                    </a>
                  </h3>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RadioInterviewsPage;

